// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"ResetPassword_formContainer__IVPKQ","primaryButton":"ResetPassword_primaryButton__ZU54C"};